<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Billers</div>
      <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew()">Add New</button>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ dataObj._id ? 'Edit Biller' : 'New Biller' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
  </div>
  <div class="modal-body">
    @if (errorMessage) {
      <div class="alert alert-danger" role="alert">{{ errorMessage }}</div>
    }
    <form #billForm="ngForm">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="required">Name</label>
              <input type="text" class="form-control" required name="name" #name="ngModel"
                [(ngModel)]="dataObj.name" required>
            </div>
            @if (name.touched && name.invalid) {
              <div class="text-danger">
                Please enter the bill name
              </div>
            }
          </div>
          <div class="col-md-6 mt-3">
            <div class="form-group">
              <label class="required">Country</label>
              <select class="form-control form-select" required name="countryId" #countryId="ngModel"
                [(ngModel)]="dataObj.countryId" required>
                <option value="">Select Country</option>
                @for (country of countries; track country) {
                  <option [value]="country._id">
                    {{ country.displayName }}
                  </option>
                }
              </select>
              @if (countryId.touched && countryId.invalid) {
                <div class="text-danger">
                  Please select a country
                </div>
              }
            </div>
          </div>
          <div class="col-md-6 mt-3">
            <div class="form-group">
              <label>Logo URL</label>
              <div class="input-group">
                <input type="text" class="form-control" name="logo" #logo="ngModel"
                  [(ngModel)]="dataObj.logo"
                  placeholder="https://...">
                  @if (dataObj.logo) {
                    <span class="input-group-text p-1">
                      <img [src]="dataObj.logo" style="height:28px; object-fit:contain;" alt="logo preview">
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="col-md-12 mt-3">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="isActive"
                  [(ngModel)]="dataObj.isActive" name="isActive">
                <label class="form-check-label" for="isActive">
                  Is Active
                </label>
              </div>
            </div>
          </div>

          <!-- Bank Account Details -->
          <div class="row mt-4">
            <div class="col-md-12">
              <h6>Bank Account Details</h6>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-group">
                <label class="required">Bank Name</label>
                <input type="text" class="form-control" required name="bankName" #bankName="ngModel"
                  [(ngModel)]="dataObj.bankAccount.bankName" required>
                @if (bankName.touched && bankName.invalid) {
                  <div class="text-danger">
                    Please enter the bank name
                  </div>
                }
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-group">
                <label>Branch Name</label>
                <input type="text" class="form-control" name="branchName" #branchName="ngModel"
                  [(ngModel)]="dataObj.bankAccount.branchName">
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-group">
                <label>SWIFT Code</label>
                <input type="text" class="form-control" name="swiftCode" #swiftCode="ngModel"
                  [(ngModel)]="dataObj.bankAccount.swiftCode">
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-group">
                <label class="required">Account Number</label>
                <input type="text" class="form-control" required name="accountNumber" #accountNumber="ngModel"
                  [(ngModel)]="dataObj.bankAccount.accountNumber" required>
                @if (accountNumber.touched && accountNumber.invalid) {
                  <div class="text-danger">
                    Please enter the account number
                  </div>
                }
              </div>
            </div>

            <div class="col-md-6 mt-2">
              <div class="form-group">
                <label>Remarks</label>
                <input type="text" class="form-control" name="remarks" #remarks="ngModel"
                  [(ngModel)]="dataObj.bankAccount.remarks">
              </div>
            </div>
          </div>

          <!-- Dynamic Fields -->
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <h6>Dynamic Fields</h6>
                <button type="button" class="btn btn-sm btn-primary" (click)="addDynamicField()">
                  <i class="bi bi-plus"></i> Add Field
                </button>
              </div>
            </div>
            @for (field of dataObj.dynamicFields; track field; let i = $index) {
              <div class="col-md-12 mt-2">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="required">Label</label>
                          <input type="text" class="form-control" required name="fieldLabel_{{i}}"
                            [(ngModel)]="dataObj.dynamicFields[i].label"
                            (blur)="dataObj.dynamicFields[i]._labelTouched = true" required>
                          @if (dataObj.dynamicFields[i]._labelTouched && !dataObj.dynamicFields[i].label) {
                            <div class="text-danger">
                              Please enter the label
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Type</label>
                          <select class="form-control" name="fieldType_{{i}}"
                            [(ngModel)]="dataObj.dynamicFields[i].type">
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label>Value</label>
                          <input type="text" class="form-control" name="fieldValue_{{i}}"
                            [(ngModel)]="dataObj.dynamicFields[i].value">
                        </div>
                      </div>
                      <div class="col-md-1">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox"
                            [(ngModel)]="dataObj.dynamicFields[i].isRequired"
                            name="fieldRequired_{{i}}">
                          <label class="form-check-label">Required</label>
                        </div>
                      </div>
                      <div class="col-md-1">
                        <button type="button" class="btn btn-sm btn-danger mt-4"
                          (click)="removeDynamicField(i)">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>

          <!-- Customer Fields -->
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center">
                <h6>Customer Fields</h6>
                <button type="button" class="btn btn-sm btn-primary" (click)="addCustomerField()">
                  <i class="bi bi-plus"></i> Add Field
                </button>
              </div>
            </div>
            @for (field of dataObj.customerFields; track field; let i = $index) {
              <div class="col-md-12 mt-2">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="required">Field Name</label>
                          <input type="text" class="form-control" required name="customerFieldName_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].fieldName"
                            (blur)="dataObj.customerFields[i]._fieldNameTouched = true" required>
                          @if (dataObj.customerFields[i]._fieldNameTouched && !dataObj.customerFields[i].fieldName) {
                            <div class="text-danger">
                              Please enter the field name
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label class="required">Label</label>
                          <input type="text" class="form-control" required name="customerFieldLabel_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].label"
                            (blur)="dataObj.customerFields[i]._labelTouched = true" required>
                          @if (dataObj.customerFields[i]._labelTouched && !dataObj.customerFields[i].label) {
                            <div class="text-danger">
                              Please enter the label
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Type</label>
                          <select class="form-control" name="customerFieldType_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].type">
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="select">Select</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label>Display Order</label>
                          <input type="number" class="form-control" name="customerFieldOrder_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].displayOrder" min="1">
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-check d-flex align-items-end">
                          <input class="form-check-input" type="checkbox"
                            [(ngModel)]="dataObj.customerFields[i].isRequired"
                            name="customerFieldRequired_{{i}}">
                          <label class="form-check-label ms-2">Required</label>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Placeholder</label>
                          <input type="text" class="form-control" name="customerFieldPlaceholder_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].placeholder">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Validation Regex</label>
                          <input type="text" class="form-control" name="customerFieldValidation_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].validationRegex"
                            pattern="^/(.*)/$|^[^/]+$">
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Validation Message</label>
                          <input type="text" class="form-control" name="customerFieldMessage_{{i}}"
                            [(ngModel)]="dataObj.customerFields[i].validationMessage">
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12 d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-danger"
                          (click)="removeCustomerField(i)">
                          <i class="bi bi-trash me-1"></i> Remove Field
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="row">
            <div class="col-md-12 mt-4 text-center">
              <button [disabled]="!billForm.valid" class="btn btn-primary active w-50"
              (click)="onSubmit(billForm.valid)">Submit</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>
